import { CreateElement } from "vue";

export function callMethod(vm: any, component: any, method: string, args: any[]) {
  return component.options.methods[method].apply(vm, args);
}

export function callRenderFunction(vm: any, component: any, h: CreateElement) {
  return component.options.render.call(vm, h);
}

export function callComputed(vm: any, component: any, name: string) {
  return component.options.computed[name].get.apply(vm);
}
